import { APICore } from './apiCore'

const api = new APICore()

function getRutas (params) {
  const baseUrl = '/rutas'
  return api.get(baseUrl, params)
}

function getRuta (id) {
  const baseUrl = `/rutas/${id}`
  return api.get(baseUrl, {})
}

function addRuta (params) {
  const baseUrl = '/rutas'
  return api.createWithFile(baseUrl, params)
}

function updateRuta (params) {
  const baseUrl = '/rutas'
  return api.updateWithFile(baseUrl, params)
}

function deleteRuta (params) {
  const baseUrl = '/rutas'
  return api.delete(baseUrl, params)
}

export { getRutas, getRuta, addRuta, updateRuta, deleteRuta }
